<template>
  <div class="w-full pb-32">
    <div
      class="md:w-4/5 lg:w-4/5 w-11/12 mx-auto mt-4 bgE4D8F5 relative z-index1"
    >
      <div class="absolute top-0 left-0 z-index--1">
        <img src="../../../assets/images/bg-des/form-t1.svg" alt="Bg des" />
      </div>
      <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
        <b-form role="form" @submit.prevent="handleSubmit(handleSend)">
          <div class="md:p-12 lg:p-12 p-6">
            <div
              class="grid md:grid-cols-2 lg:grid-cols-3 grid-cols-1 gap-x-10 gap-y-6"
            >
              <div class="">
                <p class="input-title-black">Name</p>
                <base-input
                  v-model="name"
                  placeholder="Enter your name"
                  class="border-0"
                  name="name"
                  :rules="{ required: true, alpha_spaces: true }"
                ></base-input>
              </div>
              <div class="">
                <p class="input-title-black">Email Address</p>
                <base-input
                  v-model="email"
                  placeholder="Enter your EmailID"
                  class="border-0"
                  name="email"
                  :rules="{ required: true, email: true }"
                ></base-input>
              </div>
              <div class="">
                <p class="input-title-black">Mobile No.</p>
                <base-input
                  v-model="mobile"
                  placeholder="Enter your Mobile No."
                  class="border-0"
                  name="mobile"
                  :rules="{ required: true, numeric: true }"
                ></base-input>
              </div>

              <div class="">
                <p class="input-title-black">Reason to connect</p>
                <multiselect
                  name="Reason"
                  v-model="reason"
                  :options="reasonOptions"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  placeholder="Select your Reason to Connect"
                  track-by="name"
                  label="name"
                  :preselect-first="false"
                >
                </multiselect>
                <!-- <base-input
                  v-model="reason"
                  placeholder="Enter your Reason to Connect"
                  class="border-0"
                  name="reason"
                  :rules="{ required: true }"
                ></base-input> -->
              </div>
              <div class="">
                <p class="input-title-black">Designation</p>
                <base-input
                  v-model="designation"
                  placeholder="Enter your Designation"
                  class="border-0"
                  name="designation"
                  :rules="{ required: true }"
                ></base-input>
              </div>

              <div class="">
                <p class="input-title-black">Organization</p>
                <base-input
                  v-model="organization"
                  placeholder="Enter your Organization Name"
                  class="border-0"
                  name="organization"
                  :rules="{ required: true }"
                ></base-input>
              </div>
            </div>
            <div class="pt-6">
              <p class="input-title-black">Message</p>
              <base-input
                type="textarea"
                id="textarea-rows"
                placeholder="Enter your Message"
                rows="3"
                class="border-0"
                v-model="message"
                name="message"
                :rules="{ required: true }"
              ></base-input>
            </div>
            <div class="md:pt-10 lg:pt-10 pt-6 w-full">
              <base-button
                type="primary"
                native-type="submit"
                variant="primary"
                class="lg:px-10 md:px-10 px-6 md:py-2 lg:py-2 py-1 border-2 text-base font-bold"
                >Send Message</base-button
              >
            </div>
          </div>
        </b-form>
      </validation-observer>
    </div>
    <div class="md:w-4/5 lg:w-4/5 w-11/12 mx-auto mx-auto mt-20">
      <div
        class="md:grid-cols-2 lg:grid-cols-4 grid-cols-2 grid lg:gap-8 gap-3 md:gap-8"
      >
        <div class="bgCCEFF2 md:p-6 lg:p-6 p-3 text-center rounded-lg mt-4">
          <img
            src="../../../assets/images/logo/form-gps.svg"
            alt="GPS Logo"
            class="h-8 mx-auto"
          />
          <p class="form-logo-t1 mt-4">Address</p>
          <p class="form-logo-t2 mt-2">
            Lorem Pipsum, Dolor Hsit Aamet, Consectetur Aadipiscing
          </p>
        </div>
        <div
          class="bgCCEFF2 md:p-6 lg:p-6 p-3 relative text-center rounded-lg mt-4"
        >
          <div class="cntr-align absolute">
            <img
              src="../../../assets/images/logo/form-mail.svg"
              alt="GPS Logo"
              class="h-8 mx-auto"
            />
            <p class="form-logo-t1 mt-4">Email Address</p>
            <p class="form-logo-t2 mt-2 break-words">
              caregiversaathi @gmail.com
            </p>
          </div>
        </div>
        <div class="bgCCEFF2 md:p-6 lg:p-6 p-3 text-center rounded-lg mt-4">
          <img
            src="../../../assets/images/logo/form-call.svg"
            alt="GPS Logo"
            class="h-8 mx-auto"
          />
          <p class="form-logo-t1 mt-4">Mobile Number</p>
          <p class="form-logo-t2 mt-2">
            +91 0987654321, <br />
            +91 1234567890
          </p>
        </div>
        <div
          class="bgCCEFF2 md:p-6 lg:p-6 p-3 text-center rounded-lg mt-4 relative"
        >
          <div class="cntr-align absolute">
            <img
              src="../../../assets/images/logo/form-soc.svg"
              alt="GPS Logo"
              class="h-8 mx-auto"
            />
            <p class="form-logo-t1 mt-4">Socials</p>
            <div class="mt-4 flex justify-center">
              <img
                src="../../../assets/images/logo/form-fb.svg"
                alt=" Logo"
                class="md:h-10 lg:h-10 h-6 mx-2"
              />
              <img
                src="../../../assets/images/logo/form-twi.svg"
                alt="Logo"
                class="md:h-10 lg:h-10 h-6 md:mx-8 lg:mx-8 mx-4"
              />
              <img
                src="../../../assets/images/logo/form-insta.svg"
                alt="Logo"
                class="md:h-10 lg:h-10 h-6"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import emailMixin from "@/mixins/email";
import Multiselect from "vue-multiselect";

export default {
  data() {
    return {
      designation: "",
      reason: [],
      mobile: "",
      email: "",
      name: "",
      organization: "",
      message: "",
      reasonOptions: [
        {
          name: "Future Fit Corporate Initiatives",
          value: "Future Fit Corporate Initiatives",
        },
        { name: "Advisory Services", value: "Advisory Services" },
        { name: "Learning Interventions", value: "Learning Interventions" },
        { name: "Employee Well-being", value: "Employee Well-being" },
        { name: "ESG/CSR Partnership", value: "ESG/CSR Partnership" },
      ],
    };
  },
  components: {
    Multiselect,
  },
  mixins: [emailMixin],

  methods: {
    async handleSend() {
      let reasons = this.reason.map((e) => e.name);
      const to = ["services@caregiversaathi.co.in"];
      const bcc = [
        "yash.singh@aiab.in",
        "bhavana.issar@caregiversaathi.co.in",
        "dona.mohapatra@caregiversaathi.co.in",
      ];

      const subject = "Requested Services";
      const body = `
      Name: ${this.name}<br />
      Email Address: ${this.email}<br />
      Mobile No.: ${this.mobile}<br />
      Designation: ${this.designation}<br />
      Reason: ${reasons}<br />
      Organization: ${this.organization}<br />
      Message: ${this.message}<br />
      `;
      await this.sendEmail(to, subject, body, bcc);
      this.resetForm();
      this.$swal.fire({
        // title: "Created",
        html: "<p style='text-align:center'>Thank you for submitting your details. We value your need. Allow our team 24-48 hours to get back to you.</p>",
        icon: "success",
        confirmButtonColor: "#830c81",
        showCancelButton: false,
      });
    },
    resetForm() {
      this.name = "";
      this.email = "";
      this.mobile = "";
      this.designation = "";
      this.reason = "";
      this.organization = "";
      this.message = "";
      this.$refs.formValidator.reset();
    },
  },
  mounted() {},
  computed: {},
};
</script>
